"use client";

import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { AuthInfoBox } from "@/features/auth/components/elements/auth-info-box";
import { SocialSignInButtons } from "@/features/auth/components/elements/social-sign-in-buttons";
import { AUTH_SECONDARY_BUTTON } from "@/features/auth/lib/auth-button-styles";
import type { OAuthProvider } from "@/features/auth/types/auth-flow.type";

type LinkedAccountStepProps = {
  email: string;
  provider: OAuthProvider;
  isSubmitting: boolean;
  onProviderSelect: (provider: OAuthProvider) => void;
  onBack: () => void;
};

/**
 * "Konto połączone – Google": the e-mail belongs to an account that can only
 * be used through its social provider, so the password prompt is skipped.
 */
export const LinkedAccountStep = ({
  email,
  provider,
  isSubmitting,
  onProviderSelect,
  onBack,
}: LinkedAccountStepProps) => {
  const t = useTranslations("auth");
  const providerName = t(`social.providerName.${provider}`);

  return (
    <div className="flex flex-col gap-6">
      <AuthInfoBox
        description={t("linkedAccount.description", {
          email,
          provider: providerName,
        })}
        title={t("linkedAccount.title", { provider: providerName })}
      />

      <div className="flex flex-col gap-4">
        <SocialSignInButtons
          disabled={isSubmitting}
          onSelect={onProviderSelect}
          only={provider}
        />
        <Button
          className={AUTH_SECONDARY_BUTTON}
          onClick={onBack}
          type="button"
          variant="outline"
        >
          {t("linkedAccount.backToSignIn")}
        </Button>
      </div>
    </div>
  );
};
